import React, { useEffect, useRef, useState } from "react";
import "./InputStyles.css";

interface InputProps {
  placeHolder?: string;
  value?: string;
  onChange?: (value: string) => void;
  containerStyle?: object;
  error?: boolean;
  success?: boolean;
  successMsg?: string;
  errorMsg?: string;
  readOnly?: boolean;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  infoMsg?: string;
}

const Input = ({
  placeHolder,
  value,
  onChange,
  containerStyle = {},
  error = false,
  success = false,
  successMsg = "",
  errorMsg = "",
  readOnly = false,
  onClick = () => {},
  infoMsg = ""
}: InputProps) => {
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);

    const inputElement = inputRef.current;

    if (inputElement) {
      inputElement.addEventListener("focus", handleFocus);
      inputElement.addEventListener("blur", handleBlur);
    }

    return () => {
      if (inputElement) {
        inputElement.removeEventListener("focus", handleFocus);
        inputElement.removeEventListener("blur", handleBlur);
      }
    };
  }, []);

  return (
    <div
      className={`${
        isFocused ? "FocusedInputWpr" : "inputWpr"
      } makeFlex ${error && "errorNew"}`}
      style={containerStyle}
      onClick={onClick}
    >
      <p
        className={`newFont14 latoBold darkGreyText ${
          isFocused
            ? "focusedPlaceHolder"
            : `${value ? "haveValue" : "placeHolder"}`
        } ${error && "errorTitleNew"}`}
        onClick={() => inputRef.current.focus()}
      >
        {placeHolder}
      </p>
      <input
        type="text"
        className={isFocused || value ? "focusedInputField" : "inputFieldNew"}
        value={value}
        ref={inputRef}
        onChange={e => onChange(e.target.value)}
        readOnly={readOnly}
      />
      {error && <p className="errorMsgNew">{errorMsg}</p>}
      {success && <p className="successMsgNew">{successMsg}</p>}
      {!(error || success) && <p className="infoMsgNew greyColor">{infoMsg}</p>}
    </div>
  );
};

export default Input;
